export class AutomatedActionApiV2 {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAutomatedActions({ includeGlobalEntities } = {}) {
    return this.#http.get('/api/automated-actions', {
      params: { includeGlobalEntities },
    });
  }

  async createAutomatedAction(body) {
    return this.#http.post('/api/automated-actions', body);
  }

  async editAutomatedAction(body) {
    return this.#http.put(`/api/automated-actions`, body);
  }

  async deleteAutomatedAction({ id }) {
    return this.#http.delete(`/api/automated-actions/${id}`);
  }

  async reorderAutomatedAction(body) {
    return this.#http.post('/api/automated-actions/reorder', body);
  }

  async getAutomatedActionsExpressionDefinition({ targetType } = {}) {
    return this.#http.get('/api/expression-definitions/automated-actions', {
      params: { targetType },
    });
  }

  async disableGlobalAutomatedAction({ id }) {
    return this.#http.post(`/api/automated-actions/${id}/disable`);
  }

  async enableGlobalAutomatedAction({ id }) {
    return this.#http.post(`/api/automated-actions/${id}/enable`);
  }

  async cloneGlobalAutomatedAction({ id }) {
    return this.#http.post(`/api/automated-actions/${id}/clone`);
  }
}
